import { PARTNER_TYPES_MAP } from '@/app/(main)/search-details/consts/search-details';
import type { GlobalSearchPartnerFormType } from '@/types/globalSearchApiTypes';
import { CapitalizeMarkedText } from '@/utils/capitalize';
import { getLabelValueText } from '@/utils/getLabelValueText';

export type PartnerFormTypeInput = string | GlobalSearchPartnerFormType;

const stripMarkTags = (value: string) => value.replace(/<mark>/g, '').replace(/<\/mark>/g, '');

const normalizePartnerTypeKey = (value: string) =>
  stripMarkTags(value).trim().toLowerCase().replace(/\s+/g, '_');

export const getPartnersType = (type: PartnerFormTypeInput) => {
  const displaySource = getLabelValueText(type);
  const keySource =
    typeof type === 'object' && type !== null ? getLabelValueText(type.value) : getLabelValueText(type);

  const normalizedKey = normalizePartnerTypeKey(keySource);
  const typeIcon = PARTNER_TYPES_MAP.find((entry) => entry.type === normalizedKey)?.icon ?? '';
  const displayText = stripMarkTags(displaySource).replace(/_/g, ' ');

  return `${typeIcon} ${CapitalizeMarkedText(displayText, true)}`.trim();
};
